import { render, staticRenderFns } from "./newsPageItems.vue?vue&type=template&id=5be53ae4&"
import script from "./newsPageItems.vue?vue&type=script&lang=js&"
export * from "./newsPageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports